import type { PartnerConsentDescription, PartnerConsentRequest } from 'services/partner-consent'

export const PARTNER_CONSENT_PATH = '/partners/connect'

/** Router state the consent page sends to sign-in: the partner it already described, so the banner shows at once. */
export interface PartnerSignInState {
	partnerConsent?: PartnerConsentDescription
}

/** The request a partner sent, from the consent page's query. Null when part of it is missing. */
export function readPartnerConsentRequest(params: URLSearchParams): PartnerConsentRequest | null {
	const clientId = params.get('client_id')
	const redirectUri = params.get('redirect_uri')
	const scope = params.get('scope')
	return clientId && redirectUri && scope ? { clientId, redirectUri, scope, state: params.get('state') } : null
}

/**
 * The consent request a sign-in `?to=` will return to, when it is the consent page. Only an app path counts, never a
 * full URL, so a crafted link cannot name another site.
 */
export function partnerConsentRequestIn(to: string | null): PartnerConsentRequest | null {
	const prefix = `${PARTNER_CONSENT_PATH}?`
	return to?.startsWith(prefix) ? readPartnerConsentRequest(new URLSearchParams(to.slice(prefix.length))) : null
}
